import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/standard-deviation-calculator',
  component: () => import('../../routes/StandardDeviationCalculator.svelte'),
  card: {
    id: 'standard-deviation-calculator',
    title: 'Standard Deviation Calculator',
    description: 'Calculate standard deviation, variance, mean, and more from a dataset. Supports both sample and population statistics.',
    icon: 'bar_chart',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/standard-deviation-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Standard Deviation Calculator – Calculate Sample & Population Statistics',
    description: 'Free standard deviation calculator to compute variance, mean, range, and more. Enter your dataset and get instant results for both sample (n-1) and population (n) statistics.',
  },
};

export default meta;
